import Icon from '@mui/icons-material/People';

import { GenericObject } from '@app/components/common/Table/DefaultTable/types';

import { CreateCTA } from './CreateCTA';
import { EditCTA } from './EditCTA';
import { ListCTA } from './ListCTA';

export const CTAResourceConfig = {
  list: ListCTA,
  create: CreateCTA,
  edit: EditCTA,
  icon: Icon,
  name: 'ctas',
};

export const CTA_TARGET_TYPE = {
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  MEDIA: 'MEDIA',
};

export const getCTAPayload = (values: GenericObject, logoImage: File | undefined, selectedMedia: GenericObject[]) => {
  const defaultValues = {
    id: values.id,
    name: values.name,
    heading: values.heading,
    is_published: values.is_published,
    subject: values.subject,
    sub_heading: values.sub_heading,
    description: values.description,
    related_topic_id: values.related_topic_id,
    target_type: values.target_type,
    cta_image: logoImage,
  };

  if (values.target_type === CTA_TARGET_TYPE.MEDIA) {
    return { ...defaultValues, vod_id: selectedMedia?.length ? selectedMedia[0]?.id : 0, external_link_url: null };
  }

  if (values.target_type === CTA_TARGET_TYPE.EXTERNAL_LINK) {
    return { ...defaultValues, external_link_url: values.external_link_url, vod_id: null };
  }
};
